<template>
  <header ref="headerRef" class="header" :class="{ active: activeScroll }">
    <div class="header__wrapper">
      <AdditionalInfo
        class="header__additional"
        @get-height-additional="getHeightAdditional"
      />
      <MainInfo
        class="header__main-info"
        :height-header="heightHeader"
        @get-height-main-info="getHeightMainInfo"
      />
      <RenderCacheable :max-age="86400" :cache-key="getUserLanguage.name">
        <ModalMenu />
      </RenderCacheable>
    </div>
  </header>
  <div
    v-if="headerCatalogState.active"
    class="backdrop"
    @click="hiddenCatalog"
  />
</template>

<script setup>
import { useHeaderStore } from "~~/store/headerStore";
import AdditionalInfo from "~~/modules/header/sections/AdditionalInfo.vue";
import MainInfo from "~~/modules/header/sections/MainInfo.vue";
import ModalMenu from "~~/modules/header/sections/ModalMenu.vue";
import { addScopedEventListener } from "~~/utils/eventListener";
import { useLanguageStore } from "~/store/languageStore";

const headerStore = useHeaderStore();
const headerCatalogState = headerStore.getModalCatalog;
const setHeaderHeight = headerStore.setHeightHeader;
const setAdditionalInfo = headerStore.setAdditionalInfo;
const activeCatalog = headerStore.activeCatalog;

const languageStore = useLanguageStore();
const { getUserLanguage } = storeToRefs(languageStore);

const heightAdditionalInfo = ref(0);
const heightHeader = ref(0);
const heightMainInfo = ref(0);
const activeScroll = ref(false);

const headerRef = ref(null);

function getHeightAdditional(height) {
  heightAdditionalInfo.value = height;
  setAdditionalInfo(`${height}px`);
}

function getHeightHeader() {
  heightHeader.value = headerRef.value?.offsetHeight;

  setHeaderHeight(heightMainInfo.value);
}

function getHeightMainInfo(height) {
  heightMainInfo.value = `${height}px`;
}

function stateHeader() {
  activeScroll.value = window.scrollY >= heightAdditionalInfo.value;
}

function hiddenCatalog() {
  activeCatalog(false);
  document.body.style.overflow = "auto";
}

onMounted(() => {
  getHeightHeader();
  stateHeader();
  addScopedEventListener(window, "resize", getHeightHeader);
  addScopedEventListener(window, "scroll", getHeightHeader);
  addScopedEventListener(window, "scroll", stateHeader);
});
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  z-index: 1000;

  background-color: white;

  &.active {
    margin-bottom: v-bind(heightMainInfo);

    .header__additional {
      opacity: 0;
      visibility: hidden;
    }

    .header__main-info {
      position: fixed;
      top: 0;
    }
  }

  &__main-info {
    width: 100%;

    padding: 4px 16px;

    @include bigMobile {
      padding: 8px 16px;
    }
  }

  &__additional {
    transition: opacity 0.5s ease-in-out;
  }
}
</style>
